import * as types from "../actionTypes";

export const getSummary = (pageNumber = null) => {
  return {
    type: types.PETTY_CASHIER_GET_CONTACT_SUMMARY_REQUEST,
    pageNumber
  };
};

export const getSummarySuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_CONTACT_SUMMARY_SUCCESS,
    payLoad: data
  };
};
export const getSummaryFailure = error => {
  return {
    type: types.PETTY_CASHIER_GET_CONTACT_SUMMARY_FAILURE,
    error: error
  };
};
